<template>
  <!-- Flight -->
  <div id="containerFormMapElement" class="flex h-[30px] mb-[5px]">
    <div class="w-full flex items-center">
      {{ $e("Notes et éléments") }}
    </div>
    <div class="p-[9.5px] h-full cursor-pointer aspect-square hover:bg-g1  " @click.stop.prevent="close()">
      <svg class="fill-current w-full rotate-45" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 75">
        <rect width="75" height="15" transform="translate(0 30)"></rect>
        <rect width="75" height="15" transform="translate(44.5) rotate(90)"></rect>
      </svg>
    </div>
  </div>
</template>

<script>
import Map from "@/utils/Map";

export default {
  name: "Map_MapElements_All",
  setup() {
    return {
    };
  },

  mounted() {
  },

  methods: {
    close() {
      Map.toggle_popup_mapelement(false);
    }
  },
};
</script>
